import { SearchMaterials } from "contexts/search/context";
import { Loaded, liftLoadedState } from "models/loaded";
import { TargetInventoryItem, InventoryItem } from "store/api/generatedApi";
import { usePeriodIndex } from "hooks/periodIndex";
import { useMaterials } from "contexts/search/SearchContextProvider";
import { useInventory, useTargetInventory } from "hooks/search";

export interface TargetInventoryDependencies {
  materials: SearchMaterials;
  targetInventory: TargetInventoryItem[];
  currentInventory: InventoryItem[];
}

export const useTargetInventoryDependencies =
  (): Loaded<TargetInventoryDependencies> => {
    const periodTab = usePeriodIndex();
    const materials = useMaterials();
    const [targetInventory] = useTargetInventory(periodTab);
    const [currentInventory] = useInventory();

    return liftLoadedState({ materials, targetInventory, currentInventory });
  };
